import React, { useEffect, useRef } from 'react'
import './BlockedLandingPage.scss'

interface BlockedLandingPageProps {
  htmlContent: string
}

const BlockedLandingPage: React.FC<BlockedLandingPageProps> = ({ htmlContent }) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!containerRef.current || !htmlContent) return

    let processedHtml = htmlContent.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')

    containerRef.current.innerHTML = processedHtml

    const scripts = containerRef.current.querySelectorAll('script')
    scripts.forEach((script) => {
      script.remove()
    })
  }, [htmlContent])

  if (!htmlContent) {
    return null
  }

  return (
    <div className='auth-container'>
      <div className='blocked-landing-page-container' ref={containerRef} />
    </div>
  )
}

export default BlockedLandingPage

